export default "__VITE_PUBLIC_ASSET__c639d6e6__"